<template>
  <div>
    <footer class='page-footer blue'>
      <div class='container'>
        <div class='row'>

        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page-footer {
    min-height: 300px;
    margin-bottom: -20px;
    margin-top: 20px;
  }

</style>
